import Container from '../../../../../components/Container'
import { FormMenuFoodType } from '../components/Form'
import { nameActions } from '../domain/info'
import { breadcrumbCreate } from '../domain/breadcrumb'
import { toolsCreate } from '../domain/tools/create'

const MenuFoodTypeCreate = (): JSX.Element => (
  <Container
    pageTitle={nameActions.create.name}
    breadcrumb={breadcrumbCreate}
    tools={toolsCreate}
  >
    <FormMenuFoodType typeForm="create" />
  </Container>
)

export default MenuFoodTypeCreate
